var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"Category"}},[_c('Category')],1),_c('el-tab-pane',{attrs:{"label":"Entry"}},[_c('Entry')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }